import { Component } from '@angular/core';

@Component({
  templateUrl: './check-box-combo-box.html'  
})
export class CheckBoxComboBoxComponent { 

    constructor() {
      var items = [
        { Name:'Apple' },
        { Name:'Banana' },
        { Name:'Cherry' },
        { Name:'Orange' },
        { Name:'Pineapple' },        
        { Name:'Strawberry' },
        { Name:'Tomato' },         
      ];

      this.ItemsSource = items.slice();
    }

    public ItemsSource;
    public SelectedItems;
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/check-box-combo-box/check-box-combo-box-component.ts